<template>
  <div>
    <div
      class="print"
      v-for="(pro, index) in orderInfo.detail"
      :key="index"
      style="page-break-after: always;"
    >
      <h1>
        浙江町当鞋业配货单
        <span id="bcTarget" v-if="index === 0">
          <barcode
            :value="orderInfo.order_id"
            :height="40"
            :displayValue="false"
          ></barcode>
        </span>
      </h1>
      <p class="top-line">
        <span>编号：{{ orderInfo.order_id }}</span>
        <span>单位备注：{{ orderInfo.customer_mark }}</span>
      </p>
      <p class="top-line">
        <span>用户备注：{{ orderInfo.user_mark }}</span>
        <span>客户备注：{{ orderInfo.customer_info.mark }}</span>
      </p>
      <p class="top-line">
        <span>单位编号：{{ orderInfo.customer_sn }}</span>
        <span>购买单位：{{ orderInfo.customer_name }}</span>
        <span>收货人：{{ orderInfo.consignee_name }}</span>
        <span>省：{{ orderInfo.customer_province }}</span>
        <span style="float:right">付款日期：{{ orderInfo.pay_time }}</span>
      </p>
      <table cellpadding="0" cellspacing="0" border="1">
        <thead>
          <tr>
            <th width="40">行号</th>
            <th width="65">图</th>
            <th width="60">商品名称</th>
            <th width="80">款号</th>
            <th width="80">库位</th>
            <th width="40">品牌</th>
            <th width="40">颜色</th>
            <th v-for="(item, index) in sizeArr" :key="index">
              (尺码)
              <br />数量
            </th>
            <th width="30">数量</th>
            <th v-if="isType" width="30">单价</th>
            <th v-if="isType" width="40">金额</th>
            <th width="30">零售价</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in pro" :key="i">
            <td class="center">{{ i + 1 + index * 9 }}</td>
            <td class="center">
              <img :src="item.image" alt />
            </td>
            <td>
              <p class="pro-name">{{ item.product_name }}</p>
            </td>
            <td>
              <p style="font-size: 13px">{{ item.product_sn }}</p>
              <p style="font-size: 13px">{{ item.product_code69 }}</p>
            </td>
            <td>{{ item.stock_position }}</td>
            <td>{{ item.product_brand }}</td>
            <td>{{ item.colour }}</td>
            <td class="right font-16" v-for="(v, i) in sizeArr" :key="i">
              <span v-if="!item.item[i]"></span>
              <span v-else>
                ({{ item.item[i].size }}){{ item.item[i].order_num }}
              </span>
            </td>
            <td class="right">{{ item.number }}</td>
            <td v-if="isType" class="right">{{ item.price * 1 }}</td>
            <td v-if="isType" class="right">
              {{ item.price * 1 * item.number }}
            </td>
            <td class="right">{{ item.market_price }}</td>
          </tr>
        </tbody>
      </table>
      <p class="bottom-line">
        <span>制单人：</span>
        <span>物流公司：{{ orderInfo.freight_name }}</span>
        <span>线上支付：{{ orderInfo.on_line_pay_price * 1 }}</span>
        <span>线下支付：{{ orderInfo.offline_pay_price * 1 }}</span>
        <span>物流代付：{{ orderInfo.freight_pay_price * 1 }}</span>
        <span>余额支付：{{ orderInfo.balance_pay_price * 1 }}</span>
        <span>合计数量：{{ orderInfo.total_num }}</span>
        <!-- <span v-if="isType">合计金额：{{ orderInfo.total_price * 1 }}</span> -->
      </p>
      <p class="footer-page">
        页码 {{ index + 1 }}/{{ orderInfo.detail.length }}
      </p>
    </div>
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import { getOrderAdminShow } from "@api/order";
export default {
  data() {
    return {
      sizeArr: [],
      orderInfo: {},
      orderId: "",
      isShow: 1,
      barcodeValue: "123456",
      isType: false,
      token: ""
    };
  },
  created() {
    console.log(this.$route.params);
    if (this.$route.params && this.$route.params.orderId) {
      this.orderId = this.$route.params.orderId;
      this.token = this.$route.params.token;
      this.getOrderDetal();
    }
  },
  components: {
    barcode: VueBarcode
  },
  methods: {
    formdate(date) {
      var unixTimestamp = new Date(date * 1000);
      var commonTime = unixTimestamp.toLocaleString();
      var s = commonTime.toLocaleString();
      var ss = s.replace(/年|月/g, "-").replace(/日/g, " ");
      return ss;
    },
    getOrderDetal() {
      const { orderId, isShow, token } = this;
      getOrderAdminShow({ orderId, isShow, token: token })
        .then(res => {
          this.orderInfo = res.data;
          this.sizeArr = [];
          this.orderInfo.order_time = this.formdate(res.data.order_time);
          let maxLength = Math.max.apply(
            null,
            res.data.detail.map(v => {
              return v.item.length;
            })
          );
          for (let i = 1; i <= maxLength; i++) {
            this.sizeArr.push(i);
          }
          const arr = res.data.detail;
          if (res.data.detail.length > 0) {
            var result = [];
            for (var i = 0, len = arr.length; i < len; i += 9) {
              result.push(arr.slice(i, i + 9));
            }
          }
          this.orderInfo.detail = result;
          // $("#bcTarget").barcode("1234567890128", "ean13");
        })
        .catch(e => {
          console.log(e);
          // this.orderInfo = e.data.data;
        });
    }
  }
};
</script>
<style>
@media print {

  .print {
    page-break-after: always;
  }
}
body {
  font-size: 12px;
  height:100%
}
.print {
  margin: 0 auto;
  padding: 20px;
  width: 1200px;
  height: 840px;
  box-sizing: border-box;
  page-break-after: always;
}
.print h1 {
  text-align: center;
  font-size: 22px;
  padding: 8px;
  position: relative;
}
.print h1 span {
  position: absolute;
  right: 50px;
}
.top-line {
  /* display: flex; */
  padding: 4px;
}
.top-line span {
  display: inline-block;
  width: auto;
  padding-right: 0.1rem;
}
td {
  font-size: 14px;
  padding: 0 4px;
  box-sizing: border-box;
}
.pro-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.payNum {
  overflow: hidden;
  width: 40px;
  font-size: 14px;
}
.print td img {
  width: 60px;
  height: 60px;
  object-fit: cover;
}
.bottom-line {
  vertical-align: text-top;
  padding: 8px;
  display: flex;
  justify-content: space-between;
}
.footer-page {
  width: 100%;
  text-align: right;
  box-sizing: border-box;
  padding: 5px;
  display: block;
  font-size: 14px;
}
.center {
  text-align: center;
  padding: 0;
}
.right {
  text-align: right;
}
.font-16 {
  font-size: 14px;
}
</style>
